import {store} from '../index'

const getDefaultState = () => {
    return {
        id: false,
        token: null,
        accountEmail: null,
        email: '', // !! For invitations !!
        passwordResetHash: '',
        fullName: '',
        userImage: '',
        usingInvitation: false,
        invitationIsExpired: false,
        isVerified: false,
        limitedAccess: true,
        invite: {},
        tenantAccess: null
    };
}

const state = getDefaultState()

const getters = {
    getAccountEmail: state => state.accountEmail,
    getToken: state => state.token,
    getFullName: state => state.fullName,
    getUserImage: state => state.userImage,
    getEmail: state => state.email,
    myId: state => state.id,
    getPasswordResetHash: state => state.passwordResetHash,
    isUsingInvitation: state => state.usingInvitation,
    isInvitationExpired: state => state.invitationIsExpired,
    getFullNameNoFallback: state => (state.accountEmail == state.fullName) ? '-' : state.fullName,
    isVerified: state => state.isVerified,
    isInvitationFound: state => state.email ? true : false,
    getFullNameOrEmail: state => state.full_name ? state.full_name : state.accountEmail,
    hasLimitedAccess: state => state.limitedAccess,
    isLoggedIn: state => state.accountEmail !== null,
    getInvite: state => state.invite,

    tenantHasScreeningAccess: state => state.invite, // && !! state.invite.order_id,

    getTenantAccess: state => state.tenantAccess,
    getSimplexEnabled: state => state.powerSupplyEnabled
};

const mutations = {
    resetAuthState: (state) => Object.assign(state, getDefaultState()),
    setInvite: (state, invite) => state.invite = invite,
    setId: (state, id) => state.id = id,
    setIsVerified: (state, isVerified) => state.isVerified = isVerified,
    setAccountEmail: (state, email) => state.accountEmail = email,
    setUsingInvitation: (state, using) => state.usingInvitation = using,
    setToken: (state, token) => state.token = token,
    setEmail: (state, email) => state.email = email,
    setUserImage: (state, imageUrl) => state.userImage = imageUrl,
    setFullName: (state, fullName) => state.fullName = fullName,
    setPasswordResetHash: (state, hash) => state.passwordResetHash = hash,
    setInvitationIsExpired: (state, expired) => state.invitationIsExpired = expired,
    setLimitedAccess: (state, limitedAccess) => state.limitedAccess = limitedAccess,
    setTenantAccess:(state, tenantAccess) => state.tenantAccess = tenantAccess,
    setSimplexEnabled: (state, powerSupplyEnabled) => state.powerSupplyEnabled = powerSupplyEnabled
};

const actions = {
    async logout({commit}){
        commit('resetAuthState');
        commit('resetCompaniesState');
        commit('resetContractSignatureState');
        commit('resetContractWizardState');
        commit('resetCreditCardState');
        commit('resetDraftContractsState');
        commit('resetInvitationsState');
        commit('resetLegacyContractsState');
        commit('resetPropertiesState');
        commit('resetScreeningState');
        commit('resetSigningState');
        commit('resetSubscriptionState');
        commit('resetSuccessBarState');
        commit('resetSingleDraftContract');
    },
    async fetchEmailByHash ({commit}, hash){
        commit('setInvitationIsExpired', false);
        commit('setEmail', false);
        await axios({
            method: 'POST',
            url: window.config.apiUrl + 'api/invitation/email/get',
            cancelToken: window.AuthorizationCancelSource.token,
            data:{
                hash: hash
            }
        }).then(response => {
            commit('setEmail', response.data.email);
            commit('setInvitationIsExpired', response.data.isExpired);
        })
    },
    fetchPasswordResetHash ({commit}, hash) {
        commit('setPasswordResetHash', hash);
    },
    fetchUserData({commit, getters}, options) {
        axios({
            method: 'POST',
            url: window.config.apiUrl + 'api/user/info',
            cancelToken: window.AuthorizationCancelSource.token,
        }).then(response => {
            commit('setFullName', response.data.full_name);
            commit('setAccountEmail', response.data.email);
            commit('setIsVerified', response.data.isVerified);
            commit('setSimplexEnabled', response.data.power_supply_enabled);

            if (typeof options == 'object') {
                if (typeof options.callback == 'function') {
                    options.callback();
                }
            }
        });
    },
    login({commit, dispatch},  data) {
        commit('setUsingInvitation', false);
        commit('setInvite', data.invite);
        commit('setToken', data.token);
        commit('setFullName', data.full_name);
        commit('setUserImage', data.image_url);
        commit('setAccountEmail', data.email);
        commit('setLimitedAccess', data.limited_access);
        commit('setId', data.id);
        commit('setTenantAccess', data.tenant_access);

        dispatch('fetchUserData');

        if (typeof woopra != 'undefined') {
            woopra.identify({
              email: data.email,
              name: data.full_name,
              company: data.companyName
            });
            woopra.track();
        }
    }
};

export default {
    state,
    getters,
    mutations,
    actions
}
